<template>
  <main class="w-full flex-grow p-6">
    <div class="w-full pr-0 lg:pr-2">
      <h2 class="text-3xl font-bold text-app-default mb-5">
        Highlighted Destinations
      </h2>
      <input
        v-model="table.search"
        @keyup="searchSubscriber"
        type="text"
        class="w-1/2 h-9 px-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200 mb-5"
        placeholder="Search name"
      />
    </div>

    <div class="mt-2 mb-5">
      <table class="w-full mx-auto table-auto">
        <thead class="justify-between">
          <tr class="bg-gray-600">
            <th class="px-5 py-2">
              <span class="text-gray-100 font-semibold">No</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Name</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Select</span>
            </th>
          </tr>
        </thead>
        <tbody class="bg-gray-200">
          <tr
            v-for="(sos, index) in newDest"
            :key="sos.id"
            :class="[index % 2 !== 0 ? 'bg-gray-200' : '']"
            class="bg-white border-b-2 border-gray-200"
          >
            <td class="px-5 py-2 text-center">
              {{
                table.current_page === 1
                  ? index + 1
                  : index + 1 + (table.current_page - 1) * table.per_page
              }}
            </td>
            <td class="text-center">
              <span class="font-semibold">
                {{ sos.destination_name }}
              </span>
            </td>
            <td class="">
              <div class="flex items-center justify-evenly" v-if="sos?.highlighted?.length > 0">
                <button
                  class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-sm bg-app-red hover:bg-app-darkRed text-white mb-3 font-bold"
                  type="button"
                  @click="removeDestination(sos.id)"
                >
                  Remove
                </button>
              </div>
              <div class="flex items-center justify-evenly" v-else>
                <button
                  class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-sm bg-app-green hover:bg-app-darkGreen text-white mb-3 font-bold"
                  type="button"
                  @click="selectDestination(sos.id)"
                >
                  Select
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
      <div>
        <p class="text-sm text-gray-700">
          Showing
          <span class="font-medium">
            {{ table.current_page * table.per_page - table.per_page + 1 }}
          </span>
          to
          <span class="font-medium">
            {{ table.current_page * table.per_page }}
          </span>
          of
          <span class="font-medium">{{ table.total }}</span>
          results
        </p>
      </div>
      <div>
        <nav
          class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
          aria-label="Pagination"
        >
          <button
            type="button"
            @click="previewPage"
            :disabled="table.current_page === 1"
            class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
          >
            <span class="sr-only">Previous</span>
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <div v-if="Math.ceil(table.total / table.per_page) < 5" class="">
            <button
              v-for="pg in Math.ceil(table.total / table.per_page)"
              :key="pg"
              @click="findpage(pg)"
              type="button"
              aria-current="page"
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === pg
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              {{ pg }}
            </button>
          </div>
          <div v-else class="">
            <button
              @click="findpage(1)"
              type="button"
              aria-current="page"
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === 1
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              1
            </button>

            <button
              @click="
                findpage(
                  table.current_page === 1
                    ? 2
                    : table.current_page === 2
                    ? 2
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page)
                    ? table.current_page - 3
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page) - 1
                    ? table.current_page - 2
                    : table.current_page - 1
                )
              "
              type="button"
              aria-current="page"
              :disabled="
                Math.ceil(table.total / table.per_page) - 1 ===
                  table.current_page
              "
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === 1
                  ? 'bg-white text-black'
                  : table.current_page === 2
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              {{
                table.current_page === 1
                  ? 2
                  : table.current_page === 2
                  ? 2
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? table.current_page - 3
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 1
                  ? table.current_page - 2
                  : table.current_page - 1
              }}
            </button>

            <button
              @click="
                findpage(
                  table.current_page === 1
                    ? 3
                    : table.current_page === 2
                    ? 3
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page) - 1
                    ? table.current_page - 1
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page)
                    ? table.current_page - 2
                    : table.current_page
                )
              "
              type="button"
              aria-current="page"
              :disabled="
                Math.ceil(table.total / table.per_page) - 1 ===
                  table.current_page
              "
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page ===
                Math.ceil(table.total / table.per_page) - 1
                  ? 'bg-white text-black'
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? 'bg-white text-black'
                  : table.current_page === 1
                  ? 'bg-white text-black'
                  : table.current_page === 2
                  ? 'bg-white text-black'
                  : 'bg-app-default text-white',
              ]"
            >
              {{
                table.current_page === 1
                  ? 3
                  : table.current_page === 2
                  ? 3
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 1
                  ? table.current_page - 1
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? table.current_page - 2
                  : table.current_page
              }}
            </button>

            <button
              @click="
                findpage(
                  table.current_page === 1
                    ? 4
                    : table.current_page === 2
                    ? 4
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page) - 1
                    ? Math.ceil(table.total / table.per_page) - 1
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page)
                    ? table.current_page - 1
                    : table.current_page + 1
                )
              "
              type="button"
              aria-current="page"
              :disabled="
                Math.ceil(table.total / table.per_page) - 1 ===
                  table.current_page
              "
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page ===
                Math.ceil(table.total / table.per_page) - 2
                  ? 'bg-white text-black'
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 3
                  ? 'bg-white text-black'
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? 'bg-white text-black'
                  : table.current_page > 1 &&
                    table.current_page <
                      Math.ceil(table.total / table.per_page) - 1
                  ? 'bg-white text-black'
                  : table.current_page === 1
                  ? 'bg-white text-black'
                  : 'bg-app-default text-white',
              ]"
            >
              {{
                table.current_page === 1
                  ? 4
                  : table.current_page === 2
                  ? 4
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 1
                  ? Math.ceil(table.total / table.per_page) - 1
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? table.current_page - 1
                  : table.current_page + 1
              }}
            </button>

            <button
              @click="findpage(Math.ceil(table.total / table.per_page))"
              type="button"
              aria-current="page"
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === Math.ceil(table.total / table.per_page)
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              {{ Math.ceil(table.total / table.per_page) }}
            </button>
          </div>
          <!-- <button v-for="pg in Math.ceil(table.total / table.per_page)" :key="pg" @click="findpage(pg)" type="button" aria-current="page" class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium" :class="[table.current_page === pg ? 'bg-app-default text-white' : 'bg-white text-black']">
            {{ pg }}
          </button> -->

          <button
            type="button"
            @click="nexPage"
            :disabled="
              Math.ceil(table.total / table.per_page) === table.current_page
            "
            class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
          >
            <span class="sr-only">Next</span>
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </nav>
      </div>
    </div>
    <Warning />
  </main>
</template>

<script>
import API from "../../api";
import Warning from "../../components/Warning.vue";
export default {
  name: "Destination",
  components: {
    Warning,
  },
  data() {
    return {
      destinations: [],
      highlighted: [],
      newDest: [],
      table: {
        current_page: 1,
        per_page: 10,
        search: "",
        total: 0,
      },
    };
  },
  methods: {
    searchSubscriber: function() {
      this.current_page = 1;
      this.per_page = 10;
      this.findDestination();
    },
    nexPage: function() {
      this.table.current_page = this.table.current_page + 1;
      this.findDestination();
    },
    previewPage: function() {
      this.table.current_page = this.table.current_page - 1;
      this.findDestination();
    },
    findpage: function(page) {
      this.table.current_page = page;
      this.findDestination();
    },
    detailContent: function(id) {
      this.$router.push(this.$route.path + "/" + id);
    },
    findDestination: async function() {
      try {
        let des = await fetch(
          `${API}v1/admin/cms/destination?current_page=${this.table.current_page}&per_page=${this.table.per_page}&search=${this.table.search}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        let respon = await des.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.newDest = respon.data.destinations;


        // let high = await fetch(`${API}v1/admin/cms/highlighteddestination`, {
        //   method: "GET",
        //   headers: {
        //     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        //   },
        // });
        // let result = await high.json();
        // if (result.status !== 200) {
        //   this._error("internal server error");
        //   return;
        // }
        // this.highlighted = result.data;

        // this.newDest = this.destinations.map((dest) => {
        //   let selected = false;
        //   this.highlighted.forEach((high) => {
        //     if (dest.id === parseInt(high.destination_id)) {
        //       selected = true;
        //     }
        //   });
        //   return { ...dest, selected };
        // });
        this.table.current_page = respon.data.current_page;
        this.table.per_page = respon.data.per_page;
        // this.table.search = respon.data.search
        this.table.total = respon.data.total;
      } catch (err) {
        this._error("internal server error");
      }
    },
    selectDestination: async function(destination_id) {
      let formdata = new FormData();
      formdata.append("destination_id", destination_id);
      try {
        let des = await fetch(`${API}v1/admin/cms/destination/highlighted/update`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        let respon = await des.json();
        if (respon.status === "failed") {
          this._error(respon.message);
          return;
        }
        this.findDestination();
      } catch (err) {
        this._error("internal server error");
        this.$router.go();
      }
    },
    removeDestination: async function(destination_id) {
      let formdata = new FormData();
      formdata.append("destination_id", destination_id);
      try {
        let des = await fetch(`${API}v1/admin/cms/destination/highlighted/remove`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        let respon = await des.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          this.$router.go();
          return;
        }
        this.findDestination();
      } catch (err) {
        this._error("internal server error");
        this.$router.go();
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
  },
  created: function() {
    this.findDestination();
  },
};
</script>
